'use strict';

import {addClass, addCustomEventListener, hasClass, removeClass} from './helpers';

export const replaceSymbols = (() => {
    const replaceCircle = () => {
        const _title = document.querySelector('[data-circle-title]');
        const replaceSymbol = '●';
        if (!_title || _title.innerHTML.indexOf(replaceSymbol) < 0) return;
        const splited = _title.innerHTML.split(replaceSymbol);
        let wordFirstPart = splited[0].split(' ').pop().replace(' ', '') || '';
        let wordLastPart = splited[1].split(' ').shift().replace(' ', '') || '';
        let res = '';

        for (let i = 0, l = splited.length; i < l; i++) {
            const txt = splited[i];

            if (i === 0) {
                res += txt.replace(wordFirstPart, '')
            }
            if (i > 0) {
                res += `<span class="circle__wrap">
                            ${wordFirstPart}<span class="circle">o</span>${wordLastPart}
                        </span>`;
            }
            if (i === 1) {
                res += txt.replace(wordLastPart, '')
            }
        }
        if (res !== '') {
            _title.innerHTML = res;
        }
    };

    const init = () => {
        replaceCircle();
    };

    return {
        init
    };
})();



